import i18n from '@/i18n/i18n'
import { RetailerStockOutputService } from '@/services/admin/retailerStockOutputService'
import { build_query } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const allowedFilters = ['retailer_id', 'product_id', 'brand_id', 'input_between']
export const allowedSorts = '-created_at'
export const allowedAppends = 'sales_channel'

export const state = {
  stockOutputs: [],
  meta: null
}

export const mutations = {
  SET_STOCK_OUTPUTS(state, outputs) {
    state.stockOutputs = outputs.data
    state.meta = outputs.meta
  }
}

export const actions = {
  getStockOutputsByInput({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      let retailerStockOutputService = new RetailerStockOutputService()

      let newQuery = build_query(params.query, [], [], allowedSorts, allowedAppends)

      retailerStockOutputService
        .getStockOutputsByInput(params.inputId, newQuery)
        .then(response => {
          commit('SET_STOCK_OUTPUTS', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'warning',
            message: t('store.shared.fetching_problem', {
              element: t('store.admin.retailer_stock_output.stock_inputs')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  exportRetailerStockOutputs({ commit, dispatch }, query) {
    return new Promise((resolve, reject) => {
      let retailerStockOutputService = new RetailerStockOutputService()

      let newQuery = build_query(query, allowedFilters, [], allowedSorts, allowedAppends)

      retailerStockOutputService
        .exportRetailerStockOutputs(newQuery)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.export_start', {
              element: t('store.admin.retailer_stock_output.stock_outputs')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'warning',
            message: t('store.shared.exporting_error', {
              element: t('store.admin.retailer_stock_output.stock_outputs')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  refundStockOutput({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      let retailerStockOutputService = new RetailerStockOutputService()

      retailerStockOutputService
        .refundStockOutput(params.orderId)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.retailer_stock_output.refund_stock_output_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.retailer_stock_output.refund_stock_output_error')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },

  convertToShortSale({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      let retailerStockOutputService = new RetailerStockOutputService()

      retailerStockOutputService
        .convertToShortSale(params.id)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.retailer_stock_output.convert_to_short_sale_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.retailer_stock_output.convert_to_short_sale_error')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
